import { render, staticRenderFns } from "./buscarProducto.vue?vue&type=template&id=64009ffc&scoped=true&"
import script from "./buscarProducto.vue?vue&type=script&lang=js&"
export * from "./buscarProducto.vue?vue&type=script&lang=js&"
import style0 from "./buscarProducto.vue?vue&type=style&index=0&id=64009ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64009ffc",
  null
  
)

export default component.exports